import { Controller } from 'stimulus'
import Swiper, {Navigation} from 'swiper'
Swiper.use([Navigation])

export default class extends Controller {
  static targets = ['next', 'prev', 'slider']

  connect() {
    this.initSlider()
  }

  initSlider() {
    new Swiper(this.sliderTarget, {
      slidesPerView: 1,
      speed: 600,
      autoHeight: true,
      centeredSlides: true,
      spaceBetween: 40,
      navigation: {
        prevEl: this.prevTarget,
        nextEl: this.nextTarget,
      },
      breakpoints: {
        700: {
          slidesPerView: 3,
          centeredSlidesBounds: true,
        },
        1280: {
          slidesPerView: 4,
          centeredSlides: false,
          spaceBetween: 20,
        },
      },
    })
  }

}
